import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
} from '@mui/material';
import Select from '@mui/material/Select';
import Iconify from '../iconify';
import AssetsDialog from './AssetsDialog';
import { TEAMS } from 'src/constants/teams';
import { LeagueType } from '@/@types/api.types.ts';
import { TenantsFormControl } from '@/components/form/TenantsFormControl.tsx';

const defaultState = {
  title: '',
  league_image_en: '',
  prize_image_en: null,
  league_type: 'CUSTOM',
} as unknown as LeagueType;

interface LeagueDialogProps {
  league: LeagueType;
  onSuccessHandler: (league: LeagueType) => void;
  onClose: () => void;
  open: boolean;
  isSearch: boolean;
}

export default function LeagueDialog(props: LeagueDialogProps) {
  const [league, setLeague] = useState<LeagueType>(defaultState);
  const [assetsTarget, setAssetsTarget] = useState<string | null>(null);

  useEffect(() => {
    if (props.league !== null) {
      setLeague(props.league);
    }
  }, [props]);

  const handleChange = (e: any) => {
    const { id, value } = e.target;

    setLeague((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLeague(defaultState);
    props.onSuccessHandler(league);
  };

  const onCancel = () => {
    setLeague(defaultState);
    props.onClose();
  };

  const onChoseAsset = (assetUrl: string) => {
    setLeague((prevState) => ({
      ...prevState,
      [String(assetsTarget)]: assetUrl,
    }));
    setAssetsTarget(null);
  };

  const onCloseAssetsDialog = () => {
    setAssetsTarget(null);
  };

  const handleChangetype = (event: any) => {
    setLeague((prevState) => ({
      ...prevState,
      league_type: event.target.value,
    }));
  };

  const handleChangeTeamId = (event: any) => {
    setLeague((prevState) => ({
      ...prevState,
      league_team_id: event.target.value,
    }));
  };

  const handleChangeTenant = (event: any) => {
    setLeague((prevState) => ({
      ...prevState,
      tenant: event.target.value,
    }));
  };

  if (assetsTarget !== null) {
    return (
      <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
    );
  }

  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Create Custom League</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id='title'
              label='Title'
              fullWidth
              value={league.title}
              variant='standard'
              onChange={handleChange}
            />
          </Grid>
          {!props.isSearch && (
            <>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel id='type-select-label'>Type</InputLabel>
                  <Select
                    labelId='type-label'
                    id='type-select'
                    value={league.league_type ?? 'CUSTOM'}
                    label='Type'
                    onChange={handleChangetype}
                  >
                    <MenuItem value='CUSTOM'>CUSTOM BET99</MenuItem>
                    <MenuItem value='CUSTOM_CLUB'>CLUB</MenuItem>
                    <MenuItem value='CUSTOM_LEAGUE'>LEAGUE</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel id='type-select-label'>League Team</InputLabel>
                  <Select
                    labelId='type-label'
                    id='type-select'
                    value={league.league_team_id ?? 1}
                    label='Type'
                    onChange={handleChangeTeamId}
                  >
                    {TEAMS.map((team) => (
                      <MenuItem value={team.teamId}>{team.teamName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TenantsFormControl
                  value={[league.tenant ?? '']}
                  onChange={handleChangeTenant}
                />
              </Grid>
            </>
          )}
          <Grid item xs={6}>
            <Box>Image</Box>
            {league.league_image_en ? (
              <>
                <img
                  style={{
                    margin: '0 auto',
                    width: 100,
                    background: 'grey',
                  }}
                  alt='Remy Sharp'
                  src={league.league_image_en}
                />
                <Iconify
                  icon='eva:edit-outline'
                  sx={{ width: 20, height: 20, cursor: 'pointer' }}
                  onClick={() => setAssetsTarget('league_image_en')}
                />
              </>
            ) : (
              <Iconify
                icon='eva:plus-circle-outline'
                sx={{
                  width: 20,
                  height: 20,
                  cursor: 'pointer',
                  marginTop: 2,
                  marginBottom: 2,
                }}
                onClick={() => setAssetsTarget('league_image_en')}
              />
            )}
          </Grid>
          <Grid item xs={6}>
            <Box>Image Fr</Box>
            {league.league_image_fr ? (
              <>
                <img
                  style={{
                    margin: '0 auto',
                    width: 100,
                    background: 'grey',
                  }}
                  alt='Remy Sharp'
                  src={league.league_image_fr}
                />
                <Iconify
                  icon='eva:edit-outline'
                  sx={{ width: 20, height: 20, cursor: 'pointer' }}
                  onClick={() => setAssetsTarget('league_image_fr')}
                />
              </>
            ) : (
              <Iconify
                icon='eva:plus-circle-outline'
                sx={{
                  width: 20,
                  height: 20,
                  cursor: 'pointer',
                  marginTop: 2,
                  marginBottom: 2,
                }}
                onClick={() => setAssetsTarget('league_image_fr')}
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button
          onClick={() => onSuccess()}
          autoFocus
          disabled={!league.title || !league.league_image_en}
        >
          {props.league === null ? 'Create' : 'Edit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
